"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Row = /** @class */ (function () {
    function Row() {
    }
    Object.defineProperty(Row.prototype, "cells", {
        get: function () {
            return this._cells;
        },
        set: function (value) {
            this._cells = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "animate", {
        get: function () {
            return this._animate;
        },
        set: function (value) {
            this._animate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isNew", {
        get: function () {
            return this._isNew;
        },
        set: function (value) {
            this._isNew = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isBeforeNew", {
        get: function () {
            return this._isBeforeNew;
        },
        set: function (value) {
            this._isBeforeNew = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isAfterNew", {
        get: function () {
            return this._isAfterNew;
        },
        set: function (value) {
            this._isAfterNew = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isCreated", {
        get: function () {
            return this._isCreated;
        },
        set: function (value) {
            this._isCreated = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isBeforeCreated", {
        get: function () {
            return this._isBeforeCreated;
        },
        set: function (value) {
            this._isBeforeCreated = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isAfterCreated", {
        get: function () {
            return this._isAfterCreated;
        },
        set: function (value) {
            this._isAfterCreated = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isHighlighted", {
        get: function () {
            return this._isHighlighted;
        },
        set: function (value) {
            this._isHighlighted = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isCollapsed", {
        get: function () {
            return this._isCollapsed;
        },
        set: function (value) {
            this._isCollapsed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isExpanded", {
        get: function () {
            return this._isExpanded;
        },
        set: function (value) {
            this._isExpanded = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isRemoved", {
        get: function () {
            return this._isRemoved;
        },
        set: function (value) {
            this._isRemoved = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "isGoingToRemoved", {
        get: function () {
            return this._isGoingToRemoved;
        },
        set: function (value) {
            this._isGoingToRemoved = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Row.prototype, "rowCategoryStyleDto", {
        get: function () {
            return this._rowCategoryStyleDto;
        },
        set: function (value) {
            this._rowCategoryStyleDto = value;
        },
        enumerable: true,
        configurable: true
    });
    return Row;
}());
exports.Row = Row;
//# sourceMappingURL=row.js.map